import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

/** Admin list status "Gabim" (plug-charge failed / expired). */
export function isSessionGabimStatus(status) {
  const value = String(status || '').toLowerCase();
  return value === 'error' || value === 'failed';
}

export function getSessionFailureText(session) {
  if (!session || !isSessionGabimStatus(session.status)) return null;
  return session.fail_reason_admin || session.fail_reason || null;
}

function FailurePopoverBody({ session, text }) {
  const rawText = session?.fail_reason || session?.stop_reason;
  return (
    <div className="space-y-2">
      <div className="flex items-start gap-2">
        <AlertTriangle className="w-4 h-4 text-red-400 shrink-0 mt-0.5" />
        <p className="text-sm text-zinc-100 leading-relaxed">{text}</p>
      </div>
      {rawText && session?.fail_reason_admin && rawText !== session.fail_reason_admin && (
        <p className="text-xs text-zinc-500 font-mono break-all pl-6">Kod: {rawText}</p>
      )}
    </div>
  );
}

/**
 * Status badge for sessions: failure details only after clicking "Gabim".
 */
export function SessionErrorStatusBadge({ session, label, className }) {
  const text = getSessionFailureText(session);
  const isGabim = isSessionGabimStatus(session?.status);

  if (!isGabim || !text) {
    return <span className={className}>{label}</span>;
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn(
            className,
            'cursor-pointer ring-offset-zinc-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-400/50'
          )}
          aria-label="Shiko arsyen e gabimit"
        >
          {label}
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="center"
        className="bg-zinc-900 border-white/10 text-zinc-100 w-[min(20rem,calc(100vw-2rem))] p-3"
      >
        <p className="text-xs font-medium text-red-300 mb-2">Arsyeja e gabimit</p>
        <FailurePopoverBody session={session} text={text} />
      </PopoverContent>
    </Popover>
  );
}

/** @deprecated Use SessionErrorStatusBadge — kept for exports compatibility */
export function SessionFailureNote() {
  return null;
}

export default SessionErrorStatusBadge;
